import { render, staticRenderFns } from "./PartnerDocuments.vue?vue&type=template&id=b70877e0&scoped=true&"
import script from "./PartnerDocuments.vue?vue&type=script&lang=js&"
export * from "./PartnerDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b70877e0",
  null
  
)

export default component.exports